import React from 'react';
import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {FormControl, Select, MenuItem} from '@material-ui/core';
import {useMutation} from 'react-apollo';
import {GET_CLUSTER_DATA, UPDATE_OPERATING_MODE_COMMAND} from './queries/dialog.queries';
import './styles/dialog.scss';
import {UrlasserDialog} from './';
import {useQuery} from '@apollo/react-hooks';
import CircularProgress from '@material-ui/core/CircularProgress';
import checkAuthorization from '../Authorization/Authorization';
import gql from 'graphql-tag';
import {useParams} from 'react-router-dom';
import {useRef} from 'react';

const GET_CURRENT_USER = gql`
    query {
        currentUser {
            id
            username
            name
            accessAuthorizations {
                id
                canPerformActions
            }
        }
    }
`;

const GET_PROJECT = gql`
    query central($id: String!) {
        central(id: $id) {
            id
            project_id
        }
    }
`;

const DATA_POLL_INTERVAL = 1000;

function OperatingModeTableRow({cluster, selectedOperatingMode, onOperatingModeSelected, onClusterState}) {
    const {data, loading} = useQuery(GET_CLUSTER_DATA, {variables: {id: cluster.id}, fetchPolicy: 'no-cache'});
    let actualOperatingMode = 'N/A';
    const [showFetch, setShowFetch] = useState(true);

    if (data) {
        if (data.cluster.cluster_command) {
            if (selectedOperatingMode === undefined) {
                onOperatingModeSelected(data.cluster.cluster_command.operating_mode);
                // onClusterState(data.cluster.cluster_state.operating_mode);
            }
        }

        if (data.cluster.cluster_state) {
            if (data.cluster.cluster_state.operating_mode === 0) {
                actualOperatingMode = 'Normalbetrieb';
            } else if (data.cluster.cluster_state.operating_mode === 1) {
                actualOperatingMode = 'Blindbetrieb';
            }
        }
    }
    return (
        <TableRow key={cluster.name}>
            <TableCell component="th" scope="row">
                {cluster.name}
            </TableCell>
            {loading ? (
                <TableCell component="th" scope="row">
                    <CircularProgress className="loading" />
                </TableCell>
            ) : (
                <TableCell component="th" scope="row">
                    {actualOperatingMode}
                </TableCell>
            )}
            <TableCell component="th" scope="row">
                {selectedOperatingMode === undefined || loading ? (
                    <CircularProgress className="loading" />
                ) : (
                    <FormControl>
                        <Select
                            className="operatingModeSelect"
                            value={
                                showFetch && data.cluster.cluster_command.operating_mode !== selectedOperatingMode
                                    ? data.cluster.cluster_command.operating_mode
                                    : selectedOperatingMode
                            }
                            onChange={event => {
                                setShowFetch(false);
                                onOperatingModeSelected(event.target.value);
                                onClusterState(event.target.value);
                            }}
                        >
                            <MenuItem key="operatingMode0" value={0}>
                                Normalbetrieb
                            </MenuItem>
                            <MenuItem key="operatingMode1" value={1}>
                                Blindbetrieb
                            </MenuItem>
                        </Select>
                    </FormControl>
                )}
            </TableCell>
        </TableRow>
    );
}

const SwitchOperatingModeDialog = props => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////
    const {centralID} = useParams();
    const {data: currentUserData} = useQuery(GET_CURRENT_USER, {fetchPolicy: 'cache-first'});
    const {data: currentProject} = useQuery(GET_PROJECT, {variables: {id: centralID}});
    //////////////////////////////////////////////////////////////////////////////////////////////////////
    const {source, open, onClose, onVerifyClick} = props;
    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false);
    const [changedClusters, setChangedClusters] = useState({});
    const [operatingModes, setOperatingMode] = React.useState({});
    const [changeOperatingMode] = useMutation(UPDATE_OPERATING_MODE_COMMAND);

    let allCluster = [];

    if (open) {
        source.crosssections.forEach(crosssection => {
            crosssection.ssts.forEach(sst => {
                sst.cluster.forEach(cluster => {
                    allCluster.push(cluster);
                });
            });
        });
    }

    const handleUrlasserDialogClose = () => {
        setOpenUrlasserDialog(false);
    };

    async function handleUrlasserDialogVerifyClick(username, cause, initiator) {
        // for (let [cluster_id, value] of Object.entries(operatingModes))
        // {
        //   if(operatingModes[cluster_id] >= 0 && changedClusters[cluster_id] !== operatingModes[cluster_id]){
        //     changeOperatingMode({ variables: {id: cluster_id, operating_mode: parseInt(value), username: username, cause: cause, initiator: initiator} });
        //   }
        // }
        for (let [cluster_id, value] of Object.entries(changedClusters)) {
            await changeOperatingMode({
                variables: {id: cluster_id, operating_mode: parseInt(value), username: username, cause: cause, initiator: initiator},
            });
        }
        setOpenUrlasserDialog(false);
    }

    function closeSOMDialog(username, cause, initiator) {
        handleUrlasserDialogVerifyClick(username, cause, initiator).then(() => {
            setChangedClusters({});
            onVerifyClick();
        });
    }

    const handleVerifyClicked = () => {
        checkAuthorization(currentUserData, currentProject, document.getElementById('authentication_problem'), () => {
            setOpenUrlasserDialog(true);
        });
    };

    const handleClusterState = props => {
        setChangedClusters({...changedClusters, [props.id]: props.value});
    };

    const handleOperatingModeSelect = props => {
        setOperatingMode({...operatingModes, [props.id]: props.value});
    };

    const handleClose = () => {
        setOperatingMode({});
        onClose();
    };

    return (
        <React.Fragment>
            <UrlasserDialog
                // onVerifyClick={handleUrlasserDialogVerifyClick}
                onVerifyClick={closeSOMDialog}
                onClose={handleUrlasserDialogClose}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Einstellung Betriebsart</DialogTitle>

                <DialogContent>
                    <Table size="medium" className="switchOperatingModeTable">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>aktuell</TableCell>
                                <TableCell>Befehl</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allCluster.map((cluster, i) => (
                                <OperatingModeTableRow
                                    key={i}
                                    cluster={cluster}
                                    selectedOperatingMode={operatingModes[cluster.id]}
                                    onOperatingModeSelected={value => {
                                        handleOperatingModeSelect({id: cluster.id, value: value});
                                    }}
                                    onClusterState={value => {
                                        handleClusterState({id: cluster.id, value: value});
                                    }}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <p id="authentication_problem" style={{color: 'red'}}></p>
                    <Button color="primary" onClick={handleClose}>
                        Abbrechen
                    </Button>
                    <Button color="primary" variant="contained" onClick={handleVerifyClicked}>
                        Übernehmen
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

SwitchOperatingModeDialog.propTypes = {
    source: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onVerifyClick: PropTypes.func.isRequired,
};

export default SwitchOperatingModeDialog;
